export default __webpack_public_path__ + "static/media/det2.2c6ba911.jpeg";